
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Settings, Stethoscope } from 'lucide-react';
import TreatmentList from './TreatmentList';
import { Treatment } from '@/data/treatmentData';

interface ServiceCategoryTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  dentalTreatments: Treatment[];
  cosmeticTreatments: Treatment[];
  handleToggleTreatment: (id: string, category: 'dental' | 'cosmetic') => void;
  handlePriceChange: (id: string, value: string, category: 'dental' | 'cosmetic') => void;
}

const ServiceCategoryTabs: React.FC<ServiceCategoryTabsProps> = ({
  activeTab,
  setActiveTab,
  dentalTreatments,
  cosmeticTreatments,
  handleToggleTreatment,
  handlePriceChange
}) => {
  return (
    <Tabs defaultValue="dental" value={activeTab} onValueChange={setActiveTab}>
      <TabsList className="grid w-full grid-cols-2 mb-6">
        <TabsTrigger value="dental" className="flex items-center gap-2">
          <Stethoscope className="h-4 w-4" />
          <span>Dental Services</span>
        </TabsTrigger>
        <TabsTrigger value="cosmetic" className="flex items-center gap-2">
          <Settings className="h-4 w-4" />
          <span>Cosmetic Services</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="dental">
        <TreatmentList 
          treatments={dentalTreatments}
          category="dental"
          onToggleTreatment={handleToggleTreatment}
          onPriceChange={handlePriceChange}
        />
      </TabsContent>
      
      <TabsContent value="cosmetic">
        <TreatmentList 
          treatments={cosmeticTreatments}
          category="cosmetic"
          onToggleTreatment={handleToggleTreatment}
          onPriceChange={handlePriceChange}
        />
      </TabsContent>
    </Tabs>
  );
};

export default ServiceCategoryTabs;
